import { validateOfflineToken } from './authTokenValidation';

/**
 * Access token for web fetch calls — reads authHelper's token and, when
 * offline, validates it before returning. Avoids importing offlineAuthService
 * so Metro/React Native doesn't pull in Dexie / IndexedDB.
 */
export async function getAccessTokenForFetch(): Promise<string> {
  const accessToken =
    localStorage.getItem('auth.accessToken') || localStorage.getItem('token');

  const looksOffline =
    typeof navigator !== 'undefined' &&
    typeof navigator.onLine === 'boolean' &&
    !navigator.onLine;

  if (looksOffline && accessToken) {
    const isValid = await validateOfflineToken(accessToken);
    if (!isValid) {
      console.warn('Cached token is invalid for offline use');
      return '';
    }
  }

  return accessToken || '';
}
